<template>
  <CCard class="mb-3">
    <CCardHeader class="cardHeader">
      <div class="d-md-flex">
        <p class="mb-0 me-2">Lokasi :</p>
        <AppBreadcrumb />
      </div>
    </CCardHeader>
    <CCardBody class="h-full">
      <router-view />
    </CCardBody>
  </CCard>
</template>
<script>
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'

export default {
  name: 'LayoutCard',
  components: {
    AppBreadcrumb,
  },
}
</script>
